/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TenantOfTenantPriceParser = /* #__PURE__ */ parsers.object([['id', codecString]]);
export class TenantOfTenantPrice extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantOfTenantPriceParser.decode(input).map(res => new TenantOfTenantPrice(res));
    }
    static unsafeDecode(input) {
        return TenantOfTenantPrice.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantOfTenantPriceParser.encode(data);
    }
    static schema() {
        return TenantOfTenantPriceParser.schema();
    }
}
